export default {
  aws_project_region: 'eu-central-1',
  aws_cognito_identity_pool_id: 'eu-central-1:b45f8252-15bf-4e64-9423-c6462bd9e917',
  aws_cognito_region: 'eu-central-1',
  aws_user_pools_id: 'eu-central-1_KbBDmn0FZ',
  aws_user_pools_web_client_id: '2j1antmkmjgis0m28krkfmhqo4',
  oauth: {}
};
